import { render, staticRenderFns } from "./ResourceDepartment.vue?vue&type=template&id=81c71316&"
import script from "./ResourceDepartment.vue?vue&type=script&lang=js&"
export * from "./ResourceDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDepartment.vue?vue&type=style&index=0&id=81c71316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports